import type { ReactNode } from "react";
import "./index.css";

type IProps = {
  children: ReactNode;
};

export const Form = ({ children }: IProps) => {
  return <div className="form-control">{children}</div>;
};
